import React from 'react';
import EditProfile from './EditProfile';
import DashboardLayout from '../../../components/Shop/StoreLayout/Layout/DashboardLayout';
import messages from '../../../locale/messages';

function action({ store, params, intl }) {
    const title = intl.formatMessage(messages.editProfile);

    let isStoreAuthenticated = store.getState().runtime.isStoreAuthenticated;

    if (!isStoreAuthenticated) {
      return { redirect: '/store/login' };
    };

    const id = Number(params.id);
    return {
        title,
        component: (
            <DashboardLayout>
                <EditProfile title={title} id={id} />
            </DashboardLayout>
        )
    }
}

export default action;